import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'constLabelReader',
  standalone: true,
})
export class ConstLabelReaderPipe implements PipeTransform {
  transform(value: any, labels: Record<any, string>): string | undefined {
    return labels[value] || undefined;
  }
}
